import React from 'react';
import '@elastic/eui/dist/eui_theme_light.css';
import { EuiText, EuiFlexGroup, EuiFlexItem, EuiSpacer, EuiPageTemplate,EuiPageHeader, EuiImage, EuiLink} from '@elastic/eui';
import { Header } from './components/header';
import { Footer } from './components/footer';
import hemant from '../photos/hemant-dhonde.png'
import shilpa from '../photos/shilpa-patil.png'
import archana from '../photos/archana-tanawade.png'
class People extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
            loading: false,
        }
    }

    render() {

        return (
            <>
                <EuiPageTemplate>
                    <EuiPageHeader><Header /></EuiPageHeader>
                <EuiFlexGroup gutterSize='xl'>
                <EuiFlexItem>
                        <EuiSpacer />
                        <EuiText><h2><font face='Segoe UI'>References</font></h2></EuiText>
                        <EuiSpacer size='m' />
                </EuiFlexItem>
                </EuiFlexGroup>
                <EuiFlexGroup gutterSize='m' style={{width: '100%', paddingLeft:'15%', paddingRight:'15%'}}>
                    <EuiFlexItem grow={false}><EuiImage
                        size="s"
                        hasShadow
                        src={hemant}
                    /></EuiFlexItem>
                    <EuiFlexItem><EuiText><b>Dr. Hemant B. Dhonde</b><br/>
                    <EuiText size='s'>[23 + yrs. of Teaching | Research | Industrial experience in India &amp; abroad] <br/>Director, C-Probe Technologies, LLP, Pune, India.
                        Adjunct Professor,<br/>
                        Civil Eng. Geotechnical Department Master’s Program, COEP, Pune,India<br/>
                        Director (R&amp;D) - Orion Group, Pune, India (www.ascstructures.com) <br/>
                        Principal Counsellor – EDU Higher Education &amp;; Career Counselling Experts<br/>
                        Former - Research Assistant Prof, Civil &amp; EE Dept., University of Houston, USA <br/>
                        Former Associate Prof/Head, Department .of Civil Eng. VIIT College, Pune, India<br/> 
                        LinkedIn: <EuiLink> https://www.linkedin.com/in/dr-hemant-dhonde-07317219/</EuiLink><br/>
                        +91 7774058927 | <EuiLink href="https://www.gmail.com" target="_blank">hbdhonde@gmail.com</EuiLink></EuiText>
                    </EuiText></EuiFlexItem>
                </EuiFlexGroup>
                <EuiSpacer />
                <EuiFlexGroup gutterSize='m' style={{width: '100%', paddingLeft:'15%', paddingRight:'15%'}}>
                    <EuiFlexItem grow={false}><EuiImage
                        size="s"
                        hasShadow
                        src={shilpa}
                    /></EuiFlexItem>
                    <EuiFlexItem><EuiText><b>Dr.Shilpa V. Patil</b><br/>
                    <EuiText size='s'>[18 + yrs. of Teaching | Research | Industry]<br/>
                        Professor and Head of Department of Civil Engineering <EuiLink href="https://www.viit.ac.in/component/jsn/shilpa-patil?Itemid=&amp;back=1" target="_blank" /><br/>
                        Ex – Dean- Quality Assurance<br/>
                        Vishwakarma Institute of Information Technology (VIIT), Pune <br/>
                        +91 9822512123 | <EuiLink href="https://www.gmail.com" target="_blank">shilpa.patil@viit.ac.in</EuiLink></EuiText>
                    </EuiText></EuiFlexItem>
                </EuiFlexGroup>
                <EuiSpacer />
                <EuiFlexGroup gutterSize='m' style={{width: '100%', paddingLeft:'15%', paddingRight:'15%'}}>
                    <EuiFlexItem grow={false}><EuiImage
                        size="s"
                        hasShadow
                        src={archana}
                    /></EuiFlexItem>
                    <EuiFlexItem><EuiText><b>Dr. Archana Tanawade</b><br/>
                    <EuiText size='s'>[15 + yrs. of Teaching | Research | Industry ]<br/>
                        Assistant Professor, Civil Engineering Department<EuiLink href="https://www.viit.ac.in/component/jsn/archanatanawade?Itemid=&amp;back=1" target="_blank" /><br/>
                        Industry &amp; Research coordinator,<br/>
                        Vishwakarma Institute of Information Technology Kondhwa (Bk.), Pune 411048<br/>
                        +91 7875672933 | <EuiLink href="https://www.gmail.com" target="_blank">archana.tanawade@viit.ac.in</EuiLink></EuiText>
                    </EuiText></EuiFlexItem>
                </EuiFlexGroup>
                <EuiSpacer />
            <Footer /></EuiPageTemplate>
            </>
        )
    }
};

export { People }